import MODULE_NAME from "./constants";

export const SETHEADERINTEGRATION = `${MODULE_NAME}/SETHEADERINTEGRATION`;

export const setHeaderIntegration = (value) => ({
  type: SETHEADERINTEGRATION,
  payload: { value },
});
